import { useState } from "react";
import {
  Dialog,
  DialogContent,
  Button,
  CardHeader,
  DialogActions,
  Select,
  Grid,
  MenuItem,
} from "../../../../components";
import { formatCnpjCpf, responseErros } from "../../../../utils";
import {
  history,
  MeuUsuarioService,
  SessionService,
} from "../../../../services";

const meuUsuarioService = new MeuUsuarioService();
const sessionService = new SessionService();

const DialogoFiliais = ({
  abrirDialogoFiliais,
  dados,
  setLoading,
  buscarConfiguracoesEmpresa,
}) => {
  const [empresa, setEmpresa] = useState(null);

  async function tocarToken(empresaId) {
    setLoading(true);
    const result = await meuUsuarioService.trocarToken(empresaId);
    setLoading(false);
    if (!result.isAxiosError) {
      sessionService.setToken(result.data.token);
      sessionService.setEmpresa(result.data.dados.empresa);
    } else {
      responseErros(result);
    }
  }

  async function onClickSelectEmpresa() {
    if (empresa?.id != dados?.empresa.id) {
      await tocarToken(empresa?.id);
    }
    await buscarConfiguracoesEmpresa();
    history.push("/pdv");
  }

  function onChangeSelectEmpresa(event) {
    setEmpresa(event.target.value);
  }

  return (
    <Dialog
      disableEscapeKeyDown
      fullWidth
      maxWidth="sm"
      open={abrirDialogoFiliais}
    >
      <CardHeader title="SELECIONE A EMPRESA" />
      <DialogContent>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Select
              id="empresa"
              name="empresa"
              margin="normal"
              onChange={onChangeSelectEmpresa}
              required
            >
              {dados?.usuario?.acessosEmpresas.map((empresa) => (
                <MenuItem key={empresa.id} value={empresa}>
                  {`${formatCnpjCpf(empresa.cnpjCpf)} - ${empresa.fantasia}`}
                </MenuItem>
              ))}
            </Select>
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions className="m-3">
        <Button
          variant="contained"
          color="primary"
          onClick={onClickSelectEmpresa}
        >
          ENTRAR
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DialogoFiliais;
